import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createDependencyErrorTitle: {
		id: 'business-timeline.timeline-view.chart-item-content.bar-content.dependency-handler.create-dependency-error-title',
		defaultMessage: "We couldn't link items",
		description: 'Error title informing the user attempt at creating issue link failed.',
	},
	createDependencyErrorMessage: {
		id: 'business-timeline.timeline-view.chart-item-content.bar-content.dependency-handler.create-dependency-error-message',
		defaultMessage: 'Check your connection, then give it another try.',
		description: 'Error message informing the user attempt at creating issue link failed.',
	},
	createDependencyDynamicErrorMessage: {
		id: 'business-timeline.timeline-view.chart-item-content.bar-content.dependency-handler.create-dependency-dynamic-error-message',
		defaultMessage: '{error}',
		description: 'Dynamic error message informing the user attempt at creating issue link failed.',
	},
});
